import {Chip, IconButton, Tooltip, Typography} from "@material-tailwind/react";
import {PencilIcon} from "@heroicons/react/24/solid";
import persianNumberFormat from "../../../helper/PersianNumberFormat";
import React, {useContext, useState} from "react";
import {TableHead} from "../../system/thead";
import {PaginateContext} from "../../../context/paginate";
import {ReferralContext} from "../../../context/referral";

const TABLE_HEAD = ["#", "کاربر", "عنوان", "نوع", "مقدار", "سهم معرف", "سهم معرفی شونده", "وضعیت", "عملیات"];

export function ReferralGrid() {

  const {
    setSortBy,
    sortType,
    setSortType,
  } = useContext(PaginateContext)

  const {
    referrals,
    setReferral,
    setOpen,
  } = useContext(ReferralContext);

  const [selectedHead, setSelectedHead] = useState("#")

  const headMap = {
    "#": "",
    "کاربر": "person_name",
    "وضعیت": "status",
    "عنوان": "title",
    "نوع": "type",
    "مقدار": "value",
    "سهم معرف": "referrer_share",
    "سهم معرفی شونده": "referee_share",
    "عملیات": "",
  }

  const headSortable = {
    "#": false,
    "کاربر": true,
    "وضعیت": true,
    "عنوان": true,
    "نوع": true,
    "مقدار": true,
    "سهم معرف": true,
    "سهم معرفی شونده": true,
    "عملیات": false,
  }

  return (
    <div>
      <table className="mt-4 text-left w-full">
        <TableHead
          tableHead={TABLE_HEAD}
          headSortable={headSortable}
          headMap={headMap}
          sortType={sortType}
          setSortType={setSortType}
          setSortBy={setSortBy}
          selectedHead={selectedHead}
          setSelectedHead={setSelectedHead}
        />
        <tbody className="textCenter">
        {referrals.map(
          ({
             id,
             person_name,
             person_phone,
             status,
             title,
             type,
             value,
             referrer_share,
             referee_share,
           }, index) => {
            const isLast = index === referrals.length - 1;
            const classes = isLast ? "p-4" : "p-4 border-b border-blue-gray-50";

            return (
              <tr
                key={id}>

                <td className={classes}>
                  <div className="flex justify-center">
                    <Typography color="blue-gray">
                      {persianNumberFormat(index + 1, true)}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex flex-col px-4">
                    <Typography color="blue-gray">
                      {person_name}
                    </Typography>
                    <Typography color="blue-gray">
                      {persianNumberFormat(person_phone)}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex justify-center px-4">
                    <Typography color="blue-gray" className="textRight">
                      {title}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex justify-center px-4">
                    <Chip
                      color={type === 'purchase_cashback' ? 'teal' : type === 'register_bonus' ? 'cyan' : 'amber'}
                      value={type === 'purchase_cashback' ? 'کش‌بک خرید' : type === 'register_bonus' ? 'پاداش ثبت نام' : type}
                    />
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex justify-center px-4">
                    <Typography color="blue-gray" className="textRight">
                      {`${persianNumberFormat(value, true)} ${type === 'purchase_cashback' ? '%' : type === 'register_bonus' ? 'ریال' : ''}`}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex justify-center px-4">
                    <Typography color="blue-gray" className="textRight">
                      {`${persianNumberFormat(referrer_share, true)} ${type === 'purchase_cashback' ? '%' : type === 'register_bonus' ? 'ریال' : ''}`}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex justify-center px-4">
                    <Typography color="blue-gray" className="textRight">
                      {`${persianNumberFormat(referee_share, true)} ${type === 'purchase_cashback' ? '%' : type === 'register_bonus' ? 'ریال' : ''}`}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex justify-center px-4">
                    <Chip
                      color={status === 'enable' ? 'green' : status === 'disable' ? 'red' : 'amber'}
                      value={status === 'enable' ? 'فعال' : status === 'disable' ? 'غیر فعال' : status}
                    />
                  </div>
                </td>

                <td className={classes}>
                  <Tooltip content="ویرایش">
                    <IconButton variant="text" className="text-align=right" onClick={() => {
                      setReferral(referrals[index]);
                      setOpen(true);
                    }}>
                      <PencilIcon className="h-4 w-4"/>
                    </IconButton>
                  </Tooltip>
                </td>
              </tr>
            );
          },
        )}
        </tbody>
      </table>
    </div>
  );
}